class GoogleTracker {
  constructor() {
    this.gclid = this.getParam("gclid") || this.getCookie("gclid");
    // this.gcl_aw = this.getCookie("_gcl_aw");

    this.setupCookies();
  }

  // === 公用方法 ===
  getGclid() {
    return this.gclid || this.getCookie("gclid");
  }

  // getGclAw() {
  //   return this.gcl_aw || this.getCookie("_gcl_aw");
  // }


  // === 私用工具 ===
  getParam(paramName) {
    const url = new URL(window.location.href);
    return url.searchParams.get(paramName);
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    return match ? match[1] : null;
  }

  setCookie(name, value, days = 90) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  setupCookies() {
    if (this.gclid) {
      this.setCookie("gclid", this.gclid);

      // if (!this.gcl_aw) {
      //   const timestamp = Math.floor(Date.now() / 1000);
      //   const random = Math.random().toString(36).substring(2, 10);
      //   this.gcl_aw = `GCL.${timestamp}.${random}`;
      //   this.setCookie("_gcl_aw", this.gcl_aw);
      // }

      // Clean gclid from URL
      const url = new URL(window.location.href);
      url.searchParams.delete("gclid");
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
  }
}

const googleTracker = new GoogleTracker();
export default googleTracker;
